export function LogoMark({ className = "h-8" }) {
  return (
    <img
      src="/logo-ecf-mark.png"
      alt="Logo ECFCOSTRUZIONI"
      className={`${className} w-auto`}
      draggable="false"
      data-testid="ecf-logo-mark"
    />
  );
}

export default function Logo({ compact = false }) {
  return (
    <span className="flex items-center gap-3" data-testid="ecf-logo">
      <LogoMark className={compact ? "h-8" : "h-10"} />
      <span className="flex flex-col leading-none">
        <span className="font-display text-xl font-bold uppercase tracking-wide text-white">
          ECFCOSTRUZIONI
        </span>
        <span className="mt-1 font-mono text-[9px] uppercase tracking-[0.35em] text-brand-ice">
          Tecnologie Edili
        </span>
      </span>
    </span>
  );
}
